import React from "react";
import * as TYPES from "./Auth.types";
import { success, error, abort } from "@redux-requests/core";
import {setToken, removeToken, setFlag} from "../../../utils";
import Toast from "../../../components/Common/Toast";
import ToastMessage from "../../../components/Common/ToastMessage";

const initialState = {
  isLoggedIn: false,
  loading: false,
  error: {
    message: "",
  },
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.REGISTER:
    case TYPES.VERIFY_ACCOUNT:
    case TYPES.RESET_PASSWORD:
    case TYPES.CHANGE_ACCOUNT_PASSWORD:
    case TYPES.CHANGE_ACCOUNT_EMAIL:
    case TYPES.CREATE_SESSION:
    case TYPES.LOGOUT:
    case TYPES.VALIDATE: {
      return {
        ...state,
        loading: true,
      };
    }
    case TYPES.CLEAR_ERROR: {
      return {
        ...state,
        error: {
          message: "",
        },
      };
    }
    case success(TYPES.VERIFY_ACCOUNT):
    case success(TYPES.GET_VERIFY_ACCOUNT_LINK):
        return {
          ...state,
          loading: false,
        };
    case success(TYPES.RESET_PASSWORD):
    case success(TYPES.CHANGE_ACCOUNT_PASSWORD):
      if(action.response.data.message) {
        Toast(`${action.response.data.message}`, "success")
      }
      return {
        ...state,
        loading: false,
      };
    case error(TYPES.VALIDATE):
    case abort(TYPES.VERIFY_ACCOUNT):
    case abort(TYPES.RESET_PASSWORD):
    case abort(TYPES.CHANGE_ACCOUNT_PASSWORD):
    case abort(TYPES.CHANGE_ACCOUNT_EMAIL):
    case abort(TYPES.GET_VERIFY_ACCOUNT_LINK):
    case error(TYPES.VERIFY_ACCOUNT):
    case error(TYPES.RESET_PASSWORD):
    case error(TYPES.CHANGE_ACCOUNT_PASSWORD):
    case error(TYPES.CHANGE_ACCOUNT_EMAIL):
    case error(TYPES.GET_VERIFY_ACCOUNT_LINK):
      if(action.error.response.data.message) {
        Toast(`${action.error.response.data.message}`, "error")
      }
      return {
        ...state,
        loading: false,
      };
    case success(TYPES.LOGOUT):
      removeToken();
      return {
        ...initialState,
      };
    case success(TYPES.VALIDATE):
    case success(TYPES.REGISTER):
      setFlag()
    case success(TYPES.RESET_PASSWORD):
    case success(TYPES.CHANGE_ACCOUNT_PASSWORD):
    case success(TYPES.CREATE_SESSION):
     
      if (action.response.data.accessToken) {
        setToken(action.response.data.accessToken);
      }

      return {
        ...state,
        loading: false,
        isLoggedIn: true,
      };
    case abort(TYPES.REGISTER):
    case abort(TYPES.CREATE_SESSION):
    case abort(TYPES.VALIDATE):
    case abort(TYPES.LOGOUT):
      removeToken();
      return {
        ...state,
      };
    case error(TYPES.LOGOUT):
    case error(TYPES.REGISTER):
    case abort(TYPES.REGISTER):
      if(action?.error?.response?.data?.message) {
        Toast(`${action.error.response.data.message}`, "error")
      }
      removeToken();
      return {
        ...initialState,
      };
    case error(TYPES.CREATE_SESSION):
      Toast(ToastMessage(0), "error")
      removeToken();
      return {
        ...initialState,
        error: {
          message: action.error.response.data.message || "Wrong user email!",
        },
      };
    default:
      return state;
  }
};


export default reducer;
